<template>
  <b-container fluid class="addClient">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          <i class="material-icons smallIcon" v-on:click="goBack">arrow_back_ios</i>
          Add Client
        </div>
      </b-col>
    </b-row>
    <b-row class="m-4">
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Client Name
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="text" placeholder="Client Name" v-model="client.name">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Image File
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="file" multiple :disabled=false
          @change="filesChange($event.target.name, $event.target.files[0]); fileCount = $event.target.files.length"
          accept="image/*">
      </b-col>
      <b-col lg="12" md="12" sm="12" xs="12" class="submitBtn text-left mt-5">
        <div class="p-3 text-center text-uppercase" v-on:click="addClient()">
          Add
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'

export default {
  name: 'AddClient',
  data () {
    return {
      isLoading: false,
      errors: [],
      client: {
        name: ''
      },
      image: null
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    filesChange (filename, file) {
      this.$data.image = file
    },
    addClient () {
      if (this.validateClient(this.$data.client)) {
        this.$store.dispatch('createClient', {
          data: {
            client: this.$data.client,
            token: this.$cookies.get('a').jwt
          },
          success: (res) => {
            this.uploadFile(res.body.data.id, this.$data.image)
          },
          fail: () => {
            console.log('failed add client')
          }
        })
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline')
        this.isLoading = false
      }
    },
    uploadFile (id, files) {
      const fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-client.dsk-client',
        field: 'image'
      }
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.toast('Client successfully added', 'success', 'check')
          this.$router.push('/dclients')
        },
        fail: () => {
          this.toast('Image upload failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    validateClient (client) {
      if (client.name === '' || client.name.trim() === '' || this.$data.image == null) {
        this.toast('Please fill in all fields', 'error', 'error_outline')
        return false
      } else {
        return true
      }
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  }
}
</script>

<style scoped>
.addClient {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  margin-bottom: 10px;
}
.box input {
  outline: none;
  width: 100%;
}
.submitBtn {
  background-color: #FF8F00;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.submitBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
.questionBox {
  padding-left: 0px;
  padding-right: 0px;
}
.answerBox {
  border-bottom: 1px solid #000;
}
.answerBox input {
  border: none;
}
.smallIcon {
  font-size:1em;
}
.smallIcon:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AddClient.vue